export const durationToMin = (duration: number) => Math.floor(duration / 60)
